export const pluralize = (
  count: number,
  noun: string,
  suffix: string = 's',
  singularSuffix: string = '',
  numberFormatOptions: Intl.NumberFormatOptions = {}
) => `${count.toLocaleString(undefined, numberFormatOptions)} ${noun}${count !== 1 ? suffix : singularSuffix}`;
